import styled from 'styled-components';

export const PackageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 22px;
  gap: 12px;
`;

export const PackageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #949494;
`;

export const CommittePackageName = styled.span`
  font-size: 16px;
  color: #000;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
`;

export const PackageCommitteLink = styled.a`
  color: #000;
  width: 24px;
  height: 24px;

  cursor: pointer;
  transition: color 0.2s;

  :hover {
    color: #4f4f4f;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ActionButton = styled.a`
  color: #000;
  width: 24px;
  height: 24px;
  
  svg {
    color: #000;
    cursor: pointer;
    transition: color 0.2s;
  
    :hover {
      color: #4f4f4f;
    }
  }
`;
